import React, { useState } from 'react'
import styled from 'styled-components'
import Cookies from 'universal-cookie'
import CustomImage from './Utils/CustomImage'
import WhatsIncludedGrid from './WhatsIncludedGrid'
import DividerSection from './DividerSection'
import { shouldTranslateTo } from '../utils/utils'
import { Link } from 'react-router-dom'
import { getCurrencySign } from '../utils/utils'
import {
  ContainerFlexColumn,
  ContainerFlexRow,
  PrimaryButton,
  Subtitle,
  Title,
  YouTube,
} from './Utils/CustomClasses'

const cookies = new Cookies()

const Container = styled.div`
  width: 100vw;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  flex-wrap: wrap;
`

const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 30%;
  min-width: 250px;
  max-width: 310px;

  gap: 25px;

  padding: 40px 30px;
  border-radius: 15px;
  border: 1px solid #e8e8e8;

  background: #fff;
  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.08);

  img {
    width: 80px;
  }
`

const ItAllStartsSection = styled.div`
  background-color: #ffffff;
  padding: 60px 8vw 60px 8vw;

  @media only screen and (max-width: 1280px) {
    padding: 60px 6vw 80px 6vw;
  }

  @media only screen and (max-width: 980px) {
    padding: 60px 10vw 50px 10vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 72px 7vw 50px 7vw;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

const ItAllStartsText = styled.div`
  margin: auto 0;

  @media screen and (max-width: 980px) {
    margin-bottom: 25px;
    padding: 0;
  }

  @media only screen and (min-width: 981px) {
    padding: 0 20px 0 0;
  }
`

const FullWidthButton = styled(PrimaryButton)`
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

const FullWidthButtonTwo = styled(FullWidthButton)`
  margin: 0 0 80px 0;
`

const ItAllStartsImage = styled.div`
  margin: auto 0vw;
  text-align: right;

  @media only screen and (max-width: 980px) {
    text-align: center;
  }

  video,
  img {
    width: 100%;
    max-width: 470px;
    border-radius: 15px;

    @media only screen and (max-width: 1024px) {
      max-width: 380px;
    }

    @media only screen and (max-width: 980px) {
      max-width: 100%;
      margin: 30px 0 0 0;
    }
  }
`

const TravelSections = styled.div`
  padding: 3vw 13vw 80px 13vw;
  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  @media only screen and (max-width: 980px) {
    padding: 50px 5vw 80px 5vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 50px 9vw 80px 8vw !important;
  }
`

const TravelSectionsTwo = styled(TravelSections)`
  padding: 5.5vw 13vw 80px 13vw;

  @media only screen and (max-width: 980px) {
    padding: 80px 5vw 80px 5vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 60px 9vw 80px 8vw !important;
  }
`

const CenterImage = styled.div`
  ${(props) => props.left && 'text-align: left; margin-left: -50px;'}
  img {
    width: 100%;
  }

  @media only screen and (max-width: 980px) {
    ${(props) => props.left && 'margin-left: 0px;'}
  }

  @media only screen and (max-width: 980px) and (min-width: 768px) {
    text-align: center;
    img {
      width: 80%;
    }
  }

  /* margin: auto 0; */
`

const SectionText = styled.div`
  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 0 auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const BulletListItemDiv = styled.div`
  line-height: 53px;
  margin: 0 0 20px 0;

  @media only screen and (max-width: 980px) {
    margin: 0 8vw 20px 18vw;
  }

  @media only screen and (max-width: 767px) {
    margin: 0 1vw 25px 9vw;
  }

  @media only screen and (max-width: 600px) {
    margin: 0 1vw 25px 4vw;
  }

  @media only screen and (max-width: 380px) {
    margin: 0 1vw 30px 2vw;
  }
`

const BulletListDot = styled.div`
  background-color: ${({ dotColor }) => (dotColor ? dotColor : '#fff')};
  border-radius: 50%;
  display: inline-block;
  width: 64px;
  height: 64px;
  text-align: center;
  vertical-align: middle;
  line-height: normal;
`

const BulletListText = styled(Subtitle)`
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  margin: 0 0 0 20px;
  width: 70% !important;

  @media only screen and (max-width: 323px) {
    width: 60% !important;
  }
`

const SafetySection = styled(TravelSections)`
  padding: 74px 7vw 30px 8vw !important;
`

const CustomImageWrapper = styled.div`
  & > div {
    margin: 0 auto;
  }
`

const PromoVideoSectionLight = styled.div`
  background-color: #fffbf4;
  padding: 30px 9vw 80px 9vw;

  @media only screen and (max-width: 600px) {
    padding: 50px 9vw 80px 9vw;
  }
`

const FlexRowUneven = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* flex-wrap: wrap; */

  /* > :first-child {
        width: 50%;
    }

    > :last-child {
        width: 50%;
    } */

  @media only screen and (max-width: 1024px) {
    flex-wrap: wrap;
    flex-direction: column;
    > div {
      width: 100% !important;
      /* text-align: center; */
    }
  }
`

const YouTubeContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`

const YouTubeVideo = styled(YouTube)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`

const TextLink = styled(Link)`
  color: #04a556 !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 21px;
`

function HowItWorksV3() {
  const [pageText, setPageText] = React.useState([])
  const [pageText2, setPageText2] = React.useState([])
  const [currencySign, setCurrencySign] = useState('')

  React.useEffect(() => {
    const language = shouldTranslateTo()

    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          if (pageValue === 'how-it-works-v3') {
            setPageText(pageText)
          } else {
            setPageText2(pageText)
          }
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('how-it-works-v3', language)
    getPageText('profile-pay', language)

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(cookies.get('cV'))
      setCurrencySign(currencySignData.sign)
    }
    getCurrency()
  }, [])

  const CardCustom = ({ image, title, text }) => {
    return (
      <CardBox>
        <img src={image} />
        <Title
          size="21px"
          sizemd="21px"
          sizesm="24px"
          weight="600"
          center
          dangerouslySetInnerHTML={{ __html: `${title}` }}
        />
        <Subtitle
          size="18px"
          sizemd="18px"
          sizesm="20px"
          weight="200"
          center
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </CardBox>
    )
  }

  const BulletListItem = ({ dotColor, dotNumber, itemText }) => {
    return (
      <BulletListItemDiv>
        <BulletListDot dotColor={dotColor}>
          <Title
            color="#154549"
            margin="15px auto 15px auto"
            size="24px"
            sizemd="24px"
            sizesm="24px"
            dangerouslySetInnerHTML={{
              __html: `${dotNumber}`,
            }}
          />
        </BulletListDot>
        <BulletListText
          color="#154549"
          size="20px"
          sizemd="20px"
          sizesm="19px"
          dangerouslySetInnerHTML={{
            __html: `${itemText}`,
          }}
        />
      </BulletListItemDiv>
    )
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      {/* Header / Title */}
      <ContainerFlexColumn
        center
        padding="5vh 15vw 0 15vw"
        paddingSm="4vh 8vw 0 8vw"
        background="#fffbf4"
      >
        <Title
          center
          smCenter
          color="#154549"
          size="54px"
          sizemd="50px"
          sizesm="44px"
          margin="0 0 30px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[0]}` }}
        ></Title>
        <Subtitle
          center
          weight="400"
          color="#154549"
          size="26px"
          sizemd="26px"
          sizesm="26px"
          margin="0 0 24px 0"
          marginsm="0 8px 0 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[1]}`,
          }}
        />
      </ContainerFlexColumn>

      {/* Promo video */}
      <PromoVideoSectionLight>
        <FlexRowUneven>
          <YouTubeContainer>
            <YouTubeVideo
              src={`https://www.youtube.com/embed/8YAeceFIvf8?si=IvSvEwZXHKyt2cg_`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            ></YouTubeVideo>
          </YouTubeContainer>
        </FlexRowUneven>
      </PromoVideoSectionLight>

      {/* Cards Panel */}
      <WhatsIncludedGrid pageText={pageText} color={'#F6F0E6'} />

      {/* Divider */}
      <DividerSection colorType={1} color={'#F6F0E6'} flip={false} />
      {/* It all starts... */}
      <ItAllStartsSection>
        <FlexRow>
          <ItAllStartsText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="38px"
              sizemd="3rem"
              sizesm="36px"
              dangerouslySetInnerHTML={{ __html: pageText[14] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="22px"
              margin="30px 0 30px 0"
              marginmd="30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[15] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="22px"
              margin="30px 0 40px 0"
              marginmd="30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[16] }}
            />
            <Link to="/signup">
              <FullWidthButton>
                <a>{pageText[17]}</a>
              </FullWidthButton>
            </Link>
          </ItAllStartsText>
          <ItAllStartsImage>
            <img src="/images/how-it-works-v3/it-all-starts.jpg" />
          </ItAllStartsImage>
        </FlexRow>
      </ItAllStartsSection>
      {/* Divider */}
      <DividerSection colorType={2} color={'#FFFFFF'} flip={false} />
      {/* Travel mode */}
      <TravelSections color="#F6F0E6">
        <Title
          color="#154549"
          size="30px"
          sizemd="34px"
          sizesm="30px"
          center
          margin="0 10vw 52px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[18]}`,
          }}
        ></Title>
        <FlexRow reverse gapSm="28px">
          <CenterImage>
            <img src="/images/how-it-works-v3/travel-mode.jpg" />
          </CenterImage>
          <SectionText>
            <BulletListItem
              dotColor="#FFFBF4"
              dotNumber={pageText[19]}
              itemText={pageText[20]}
            />
            <BulletListItem
              dotColor="#FFFBF4"
              dotNumber={pageText[21]}
              itemText={pageText[22]}
            />
            <BulletListItem
              dotColor="#FFFBF4"
              dotNumber={pageText[23]}
              itemText={pageText[24]}
            />
            <BulletListItem
              dotColor="#FFFBF4"
              dotNumber={pageText[25]}
              itemText={pageText[26]}
            />
          </SectionText>
        </FlexRow>
      </TravelSections>
      {/* Homebird mode */}
      <TravelSectionsTwo color="#FFFBF4">
        <Title
          color="#154549"
          size="30px"
          sizemd="34px"
          sizesm="30px"
          center
          margin="0 10vw 52px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[27]}`,
          }}
        ></Title>
        <FlexRow gapSm="28px">
          <SectionText>
            <BulletListItem
              dotColor="#F6F0E6"
              dotNumber={pageText[28]}
              itemText={pageText[29]}
            />
            <BulletListItem
              dotColor="#F6F0E6"
              dotNumber={pageText[30]}
              itemText={pageText[31]}
            />
            <BulletListItem
              dotColor="#F6F0E6"
              dotNumber={pageText[32]}
              itemText={pageText[33]}
            />
            <BulletListItem
              dotColor="#F6F0E6"
              dotNumber={pageText[34]}
              itemText={pageText[35]}
            />
          </SectionText>
          <CenterImage>
            <img src="/images/how-it-works-v3/homebird-mode.jpg" />
          </CenterImage>
        </FlexRow>
      </TravelSectionsTwo>
      {/* Divider */}
      <DividerSection colorType={3} color={'#FFFBF4'} flip={false} />
      {/* Cards Panel 2 */}
      <ContainerFlexColumn
        center
        padding="6vh 15vw 6vh 15vw"
        paddingSm="4vh 5vw 6vh 5vw"
        background="#FFEADC"
      >
        <Title
          color="#154549"
          size="30px"
          sizemd="1.6rem"
          sizesm="30px"
          center
          margin="0 10vw 40px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[36]}`,
          }}
        ></Title>
        <Subtitle
          center
          weight="300"
          color="#154549"
          size="22px"
          sizemd="22px"
          sizesm="22px"
          margin="0 0 50px 0"
          marginsm="0 8px 40px 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[37]}`,
          }}
        />
        <Link to="/signup">
          <FullWidthButtonTwo>
            <a>{pageText[38]}</a>
          </FullWidthButtonTwo>
        </Link>
        <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
          <CardCustom
            image="/images/how-it-works-v3/info-ic-7.svg"
            title={pageText[39]}
            text={pageText[40]}
          />
          <CardCustom
            image="/images/how-it-works-v3/info-ic-8.svg"
            title={pageText[41]}
            text={pageText[42]}
          />
          <CardCustom
            image="/images/how-it-works-v3/info-ic-9.svg"
            title={pageText[43]}
            text={pageText[44]}
          />
          <CardCustom
            image="/images/how-it-works-v3/info-ic-10.svg"
            title={pageText[45]}
            text={pageText[46]}
          />
          <CardCustom
            image="/images/how-it-works-v3/info-ic-11.svg"
            title={pageText[47]}
            text={pageText[48]}
          />
          <CardCustom
            image="/images/how-it-works-v3/info-ic-12.svg"
            title={pageText[49]}
            text={pageText[50]}
          />
        </CustomContainerFlexRow>
      </ContainerFlexColumn>

      {/* Trust & Security / ID */}
      <SafetySection>
        <FlexRow gap="50px">
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="30px"
              dangerouslySetInnerHTML={{ __html: pageText[51] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="22px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[52] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="30px"
              dangerouslySetInnerHTML={{ __html: pageText[53] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="22px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[54] }}
            />
          </SectionText>
          <CustomImageWrapper>
            <CustomImage
              imageBig={'/images/homepage-v2/marie-big.jpg'}
              imageSmall={'/images/homepage-v2/marie-small.jpg'}
              name={pageText[55]}
              text={pageText[56]}
              country={'Ireland'}
              countryFlag={'ie'}
            />
          </CustomImageWrapper>
        </FlexRow>
      </SafetySection>
      {/* Value Build / Pay */}
      <TravelSections>
        <FlexRow reverse>
          <CenterImage>
            <img src="/images/how-it-works-v3/pay-as-you-wish.jpg" />
          </CenterImage>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="30px"
              dangerouslySetInnerHTML={{ __html: pageText[57] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="22px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[58] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="30px"
              dangerouslySetInnerHTML={{ __html: pageText[59] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="22px"
              margin="0 0 20px 0"
              dangerouslySetInnerHTML={{ __html: pageText[60] }}
            />
            <TextLink to="/prices">{pageText[64]}</TextLink>
          </SectionText>
        </FlexRow>
      </TravelSections>

      {/* Divider */}
      <DividerSection colorType={5} color={'#FFFFFF'} flip={false} />

      {/* Become a Member */}
      <ContainerFlexColumn
        center
        padding="8vh 15vw 6vh 15vw"
        paddingSm="7vh 5vw 4vh 5vw"
        background="#154549"
      >
        <Title
          color="#FFFFFF"
          size="46px"
          sizemd="40px"
          sizesm="38px"
          center
          margin="0 10vw 40px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[61]}`,
          }}
        ></Title>
        <Subtitle
          center
          weight="300"
          color="#FFFFFF"
          size="22px"
          sizemd="22px"
          sizesm="22px"
          margin="0 7vw 50px 7vw"
          marginsm="0 8px 40px 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[62]}`,
          }}
        />
        <Link to="/signup">
          <FullWidthButtonTwo>
            <a>{pageText[63]}</a>
          </FullWidthButtonTwo>
        </Link>
      </ContainerFlexColumn>
    </Container>
  )
}

export default HowItWorksV3
